import * as types from '../../constants/app/inAppRankSystemConstants';

export const rankSystemListRequest = ({
  callback,
  error,
}) => ({
  type: types.RANK_SYSTEM_LIST_REQUEST,
  callback,
  error
});

export const rankSystemUpdateRequest = ({
  settingNo,
  rankType,
  lastRank,
  targetType,
  withoutTarget,
  rankDetail,
  callback,
  error,
}) => ({
  type: types.RANK_SYSTEM_UPDATE_REQUEST,
  settingNo,
  rankType,
  lastRank,
  targetType,
  withoutTarget,
  rankDetail,
  callback,
  error,
})
